import React, { useState } from 'react';
import { Dialog, DialogContent } from '../Dialog';
import { useNavigate } from 'react-router-dom';
import { Search, Radar, ShieldAlert, Users, Globe, Briefcase, FileText, Bot, Gavel, Activity, BarChart2, Flag, Fingerprint, MapPin, Network, MessageSquareWarning, Crosshair, FileSearch, LayoutDashboard, Eye, Map, TrendingUp, Swords, Megaphone, ExternalLink, User, Settings, HelpCircle } from 'lucide-react';
const items = [{
  icon: LayoutDashboard,
  label: 'Executive Dashboard',
  group: 'Modul',
  path: '/dashboard'
}, {
  icon: Crosshair,
  label: 'War Room',
  group: 'Modul',
  path: '/war-room'
}, {
  icon: Bot,
  label: 'Presidential Digital Twin',
  group: 'Modul',
  path: '/digital-twin'
}, {
  icon: FileText,
  label: 'Daily Brief',
  group: 'Modul',
  path: '/daily-brief'
}, {
  icon: LayoutDashboard,
  label: 'Narrative Calendar',
  group: 'Modul',
  path: '/narrative-calendar'
}, {
  icon: Bot,
  label: 'AI Presidential Analyst',
  group: 'Modul',
  path: '/ai-analyst'
}, {
  icon: Radar,
  label: 'Hot Issue Radar',
  group: 'Modul',
  path: '/hot-issue'
}, {
  icon: Activity,
  label: 'Sentiment Monitoring',
  group: 'Modul',
  path: '/sentiment'
}, {
  icon: Crosshair,
  label: 'Shadow Narrative',
  group: 'Modul',
  path: '/shadow-narrative'
}, {
  icon: MessageSquareWarning,
  label: 'Public Grievance',
  group: 'Modul',
  path: '/public-grievance'
}, {
  icon: ShieldAlert,
  label: 'Threat Intelligence',
  group: 'Modul',
  path: '/threat-intel'
}, {
  icon: Network,
  label: 'Hybrid Threats',
  group: 'Modul',
  path: '/hybrid-threats'
}, {
  icon: Fingerprint,
  label: 'Digital Escort Mode',
  group: 'Modul',
  path: '/digital-escort'
}, {
  icon: MapPin,
  label: 'Visit Intelligence',
  group: 'Modul',
  path: '/visit-intel'
}, {
  icon: Eye,
  label: 'Deepfake Detection',
  group: 'Modul',
  path: '/deepfake'
}, {
  icon: Network,
  label: 'Actor Network',
  group: 'Modul',
  path: '/actor-network'
}, {
  icon: Users,
  label: 'Buzzer & Bot Detection',
  group: 'Modul',
  path: '/bot-detection'
}, {
  icon: Globe,
  label: 'Foreign Influence',
  group: 'Modul',
  path: '/foreign-influence'
}, {
  icon: BarChart2,
  label: 'IPOLEKSOSBUDHANKAM',
  group: 'Modul',
  path: '/ipoleksosbudhankam'
}, {
  icon: Flag,
  label: 'Astagatra Digital',
  group: 'Modul',
  path: '/astagatra'
}, {
  icon: Map,
  label: 'Geospatial Intel',
  group: 'Modul',
  path: '/geospatial'
}, {
  icon: TrendingUp,
  label: 'Policy Impact',
  group: 'Modul',
  path: '/policy-impact'
}, {
  icon: Swords,
  label: 'Program War Room',
  group: 'Modul',
  path: '/program-war-room'
}, {
  icon: Briefcase,
  label: 'Command Tasking',
  group: 'Modul',
  path: '/command-tasking'
}, {
  icon: Activity,
  label: 'Crisis Simulation',
  group: 'Modul',
  path: '/crisis-simulation'
}, {
  icon: Megaphone,
  label: 'Response Recommender',
  group: 'Modul',
  path: '/response-recommender'
}, {
  icon: Network,
  label: 'Ministry Mapping',
  group: 'Modul',
  path: '/ministry-mapping'
}, {
  icon: Gavel,
  label: 'Legal Evidence',
  group: 'Modul',
  path: '/legal-evidence'
}, {
  icon: ExternalLink,
  label: 'Platform Reporting',
  group: 'Modul',
  path: '/platform-reporting'
}, {
  icon: FileSearch,
  label: 'Case Management',
  group: 'Modul',
  path: '/case-management'
}, {
  icon: Briefcase,
  label: 'Analyst Workbench',
  group: 'Modul',
  path: '/workbench'
}, {
  icon: FileText,
  label: 'Reports',
  group: 'Modul',
  path: '/reports'
}, {
  icon: Bot,
  label: 'AI Configuration',
  group: 'Modul',
  path: '/ai-config'
}, {
  icon: User,
  label: 'Profil Pengguna',
  group: 'Modul',
  path: '/profile'
}, {
  icon: Settings,
  label: 'Pengaturan',
  group: 'Modul',
  path: '/settings'
}, {
  icon: HelpCircle,
  label: 'Bantuan & FAQ',
  group: 'Modul',
  path: '/help'
}, {
  icon: Radar,
  label: 'Harga beras melambung',
  group: 'Isu',
  path: '/hot-issue'
}, {
  icon: Radar,
  label: 'Deepfake audio Presiden',
  group: 'Isu',
  path: '/threat-intel'
}, {
  icon: Radar,
  label: 'Hoaks bansos pangan',
  group: 'Isu',
  path: '/hot-issue'
}, {
  icon: Users,
  label: 'Budi Santoso (@budis_pengamat)',
  group: 'Aktor',
  path: '/actor-network'
}, {
  icon: Users,
  label: 'Buzzer Cluster A',
  group: 'Aktor',
  path: '/bot-detection'
}, {
  icon: MapPin,
  label: 'Papua',
  group: 'Wilayah',
  path: '/visit-intel'
}, {
  icon: MapPin,
  label: 'Jawa Tengah',
  group: 'Wilayah',
  path: '/public-grievance'
}];
export function CommandSearch({
  open,
  onOpenChange
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const [q, setQ] = useState('');
  const nav = useNavigate();
  const filtered = q ? items.filter(i => i.label.toLowerCase().includes(q.toLowerCase())) : items;
  const grouped = filtered.reduce<Record<string, typeof items>>((acc, i) => {
    ;
    (acc[i.group] ||= []).push(i);
    return acc;
  }, {});
  return <Dialog open={open} onOpenChange={onOpenChange} data-id="element-349">
      <DialogContent className="max-w-xl p-0 gap-0 overflow-hidden" data-id="element-350">
        <div className="border-b border-border/50 px-4 py-3 flex items-center gap-3" data-id="element-351">
          <Search className="size-4 text-muted-foreground" data-id="element-352" />
          <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Cari isu, aktor, wilayah, atau modul..." className="flex-1 bg-transparent outline-none text-sm placeholder:text-muted-foreground/50" data-id="element-353" />
          <kbd className="font-mono text-[9px] text-muted-foreground bg-muted px-1.5 py-0.5 rounded" data-id="element-354">
            ESC
          </kbd>
        </div>
        <div className="max-h-[400px] overflow-y-auto p-2" data-id="element-355">
          {Object.entries(grouped).length === 0 && <p className="text-center text-sm text-muted-foreground py-8" data-id="element-356">
              Tidak ada hasil.
            </p>}
          {Object.entries(grouped).map(([group, list]) => <div key={group} className="mb-2" data-id="element-357">
              <p className="font-mono text-[10px] uppercase text-muted-foreground px-2 py-1" data-id="element-358">
                {group}
              </p>
              {list.map(i => <button key={i.label} onClick={() => {
            nav(i.path);
            onOpenChange(false);
            setQ('');
          }} className="w-full flex items-center gap-3 px-2 py-2 rounded hover:bg-muted/50 transition text-left" data-id="element-359">
                  <i.icon className="size-4 text-muted-foreground" data-id="element-360" />
                  <span className="text-sm flex-1" data-id="element-361">{i.label}</span>
                  <span className="font-mono text-[9px] text-muted-foreground" data-id="element-362">
                    {i.path}
                  </span>
                </button>)}
            </div>)}
        </div>
      </DialogContent>
    </Dialog>;
}